<template>
  <draggable :group="group" :sort="false" :list="list" class="draggable-col-container">
    <div v-for="element in list" :key="`element-${element.id}`" class="border-bottom draggable-item">
      <div class="card-body p-3">
        <div class="d-flex align-items-center justify-content-between">
          {{element.data[itemName]}}
          <div v-b-toggle="`element-${element.id}-options`">
            <fa-icon :icon="['fas','ellipsis-v']" fixed-width></fa-icon>
          </div>
        </div>
        <b-collapse :id="`element-${element.id}-options`">
          <ul class="m-0 mt-2 pl-4">
            <li v-for="option in element.data.optionen" :key="`option-${option.id}`">
              {{option.nameKurz}}: {{option.uvpBruttoAbweichung | currency}}
            </li>
          </ul>
        </b-collapse>
      </div>
    </div>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'DraggableListComponent',
  components: {
    draggable
  },
  props: {
    group: {
      type: String,
      default: 'group'
    },
    itemName: {
      type: String,
      default: 'name'
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>

<style scoped>
.draggable-col-container {
  height: 398px;
  overflow-y: scroll;
}
.draggable-item {
  cursor: move;
}
</style>